module.exports = __webpack_public_path__ + "static/media/lili.845b1639.jpg";